<template>
  <div class="col-big-vbspace basic-form">
    <div
      class="col-vspace flex-radio"
      :class="active !== 'date' ? 'flex-radio--disabled' : false"
    >
      <div class="flex-radio__input">
        <input
          type="radio"
          name="type-choice"
          value="date"
          id="type-choice-date"
          v-model="active"
          @focus="focusDate"
        />
        <label
          for="type-choice-date"
          class="flex-radio__input__box"
        ></label>
      </div>
      <div class="flex-radio__data">
        <label class="label--textarea" for="choice-list">Date</label>

        <DatePicker
          :disabled="active !== 'date'"
          v-model="innerDate"
          @focus="focusDate"
        />
      </div>
    </div>

    <p class="big-title bold">OU</p>

    <div
      class="col-vspace flex-radio"
      :class="active !== 'own' ? 'flex-radio--disabled' : false"
    >
      <div class="flex-radio__input">
        <input
          type="radio"
          name="type-choice"
          value="own"
          id="type-choice-own"
          v-model="active"
          @focus="focusInput"
        />
        <label
          for="type-choice-own"
          class="flex-radio__input__box"
        ></label>
      </div>

      <div class="flex-radio__data">
        <label class="label--textarea" for="choice-list">
          Je crée mon idée géniale (max.{{ maxLength }} caractères)
        </label>

        <input
          type="text"
          class="classic-input tupper"
          v-model="innerMessage"
          :maxlength="maxLength"
          @focus="focusInput"
          @blur="backName"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { DatePicker } from '../../utils';
import { formatDate } from '../../../mixins';

export default {
  components: { DatePicker },

  mixins: [formatDate],

  props: {
    maxLength: {
      type: Number,
      default: 12,
    },
  },

  data() {
    return {
      active: 'date',
      default: '',
      message: 'MON IDÉE GÉNIALE',
      date: this.today(),
    };
  },

  created() {
    this.default = this.message;
  },

  watch: {
    active() {
      this.$emit(
        'change-name',
        this.active === 'date' ? this.date : this.message,
      );
    },
  },

  computed: {
    innerMessage: {
      get() {
        return this.message;
      },
      set(newValue) {
        this.message = newValue.toUpperCase();
        this.default = this.message;
        this.$emit('change-name', newValue.toUpperCase());
      },
    },

    innerDate: {
      get() {
        return this.date;
      },
      set(newValue) {
        this.date = newValue;
        this.$emit('change-name', newValue);
      },
    },
  },

  methods: {
    focusInput() {
      this.active = 'own';
      this.$emit('change-name', this.message);
      this.$nextTick(() => {
        this.message = '';
      });
    },

    backName() {
      this.message = this.default;
    },

    focusDate() {
      this.active = 'date';
      this.$emit('change-name', this.date);
    },

    today() {
      return this.prettyDate(Date.now());
    },
  },
};
</script>
